export default "__VITE_ASSET__c4903d07__"